export default "__VITE_PUBLIC_ASSET__f6be75be__"